@if (isBorrow) {
<sg-button
  text="Borrow"
  variant="primary"
  [size]="'medium'"
  [isLoading]="isLoading$ | async"
  (onClick)="onClick('borrow')"
  data-test="borrow-button"></sg-button>
} @else {
<sg-button
  class="sg-special-rate-request-btn"
  text="Request Rate"
  variant="ghost-secondary-on-color"
  [size]="'small'"
  [isLoading]="isLoading$ | async"
  [satPopoverAnchor]="rateRequestPopover"
  (onClick)="onClick('rate-request')"
  data-test="request-rate-button"></sg-button>
<sat-popover #rateRequestPopover verticalAlign="above">
  <div data-test="rate-request-tooltip-container" class="sg-rate-request-tooltip-container sg-flex-column">
    <span class="popup-header" data-test="popup-header">Request Rate</span>
    <span class="popup-text">{{ popoverMessage }}</span>
    <button class="sg-no-padding sg-close-icon" mat-button (click)="rateRequestPopover.close()" data-test="popup-close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</sat-popover>
}
